"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  /**
   * @ngdoc object
   * @name vehicle.controller:VehicleCtrl
   *
   * @description
   *
   */

  angular.module("vehicles").controller("VehicleCtrl", VehicleCtrl);

  function VehicleCtrl($scope, $rootScope, $timeout, $controller, FormlyService, CustomListsService, UsersService, VehiclesService, InsurerContractsService, SyncConfigsService, params) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "VehicleCtrl";

    console.log("params=", params);

    vm.oneAtATime = true;

    Promise.all([UsersService.getArrayByPosition(), UsersService.remoteSelectArray([$rootScope.defaultManagerValue, $rootScope.rhManagerValue, $rootScope.qseManagerValue, $rootScope.fleetManagerValue, $rootScope.other1ManagerValue, $rootScope.other2ManagerValue])]).then(function (values) {
      vm.arrayDriver = values[0];
      vm.arrayManageur = values[1];

      // Add "unselected" option:
      vm.arrayDriver.unshift({ name: "A PRECISER OU NON TROUVE", value: null });

      $controller("CreateBaseController", {
        vm: vm,
        $scope: $scope,
        service: VehiclesService,
        listPage: "vehicles",
        nameModel: "un véhicule",
        params: params
      });
    });

    vm.model = {};

    vm.ready = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return SyncConfigsService.findOne({
                filter: {
                  where: {
                    customerId: $rootScope.$selectedCustomerId.replace("$", "")
                  },
                  fields: { software: true }
                }
              });

            case 2:
              vm.syncConfig = _context.sent;


              $timeout(function () {
                vm.previousPlateNumber = vm.model.plateNumber;
                vm.createFields();
              }, 0);

              vm.userRole = $rootScope.$user.role;

              if (vm.model.type === "VLREM") {
                vm.model.type = "VUL";
              }
              if (vm.model.type === "VUREM") {
                vm.model.type = "VU";
              }
              if (vm.model.type === "REM") {
                vm.model.type = "PL";
              }

              if (vm.model._driverIds) {
                vm.model._driverIds = vm.model._driverIds.map(function (item) {
                  return "$" + item;
                });
              } else {
                vm.model._driverIds = [];
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    vm.check = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var allowSave, value, responseToCheck;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              allowSave = true;


              if (!vm.model.plateNumber) {
                Notiflix.Notify.failure("Vous n'avez pas indiqué l'immatriculation.");
                allowSave = false;
              }

              if ((!vm.model.groupsId || vm.model.groupsId.length === 0) && !vm.model._id // Mandatory only if creation
              ) {
                  Notiflix.Notify.failure("Au moins un groupe doit être associé à ce véhicule.");
                  allowSave = false;
                }

              if (!(vm.model.plateNumber && vm.model.plateNumber.length > 0 && vm.model.plateNumber != vm.previousPlateNumber)) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return VehiclesService.count({
                customerId: $rootScope.$selectedCustomerId,
                plateNumber: vm.model.plateNumber
              });

            case 6:
              value = _context2.sent;

              if (value >= 1) {
                Notiflix.Notify.failure("Cette immatriculation est déjà associé à un autre véhicule");
                allowSave = false;
              } else if (value == 0) {
                console.log("plate number checked !");
              } else {
                Notiflix.Notify.failure("Erreur plateforme : rééssayer ou contacter le support");
                allowSave = false;
              }

            case 8:
              if (!(vm.model.toCheck === true && $rootScope.$user.role !== "user" && allowSave)) {
                _context2.next = 13;
                break;
              }

              _context2.next = 11;
              return swal({
                title: "ATTENTION : Voulez-vous vraiment approuver la fiche de ce v\xE9hicule ?",
                text: "Approuvez-vous cette fiche cr\xE9\xE9e, soit automatiquement suite \xE0 une d\xE9claration de sinistre, soit par un utilisateur ni RH ni Administrateur ?",
                icon: "warning",
                dangerMode: true,
                buttons: {
                  cancel: "Non",
                  confirm: "Oui"
                }
              });

            case 11:
              responseToCheck = _context2.sent;


              if (!responseToCheck) {
                allowSave = false;
              }

            case 13:

              if (allowSave) {
                if (!vm.model._id && $rootScope.$user.role === "user") {
                  // if new and not hr/admin
                  vm.model.toCheck = true;
                } else if (vm.model.toCheck === true && $rootScope.$user.role !== "user") {
                  vm.model.toCheck = false;
                }

                if (vm.model._driverIds) {
                  vm.model._driverIds = vm.model._driverIds.map(function (item) {
                    return item.replace("$", "");
                  });
                }

                vm.save();
              }

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    vm.createFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var typesVehiclesList;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return CustomListsService.getSelectArray("typeVehicleV2");

            case 2:
              typesVehiclesList = _context3.sent;

              typesVehiclesList = typesVehiclesList.filter(function (item) {
                return !["VLREM", "VUREM", "REM"].includes(item.value);
              });
              typesVehiclesList = typesVehiclesList.map(function (item) {
                return { value: item.value, name: item.name.split(" (")[0] };
              });

              _context3.t0 = vm.syncConfig && vm.model.internalNumber ? {
                template: "<label>Immatriculation :</label><br/><input value=\"" + (vm.model.plateNumber ? vm.model.plateNumber : "") + "\" class=\"form-control\" disabled/><div style=\"padding-top: 6px;\"/>",
                className: "col-xs-12 col-sm-12"
              } : FormlyService.text("plateNumber", "Immatriculation", true, {
                className: "col-xs-12 col-sm-12"
              });
              _context3.t1 = vm.syncConfig ? {
                template: "<label>ID " + vm.syncConfig.software + " :</label><br/><input value=\"" + (vm.model.internalNumber ? vm.model.internalNumber : "") + "\" class=\"form-control\" disabled/><div style=\"padding-top: 6px;\"/>",
                className: "col-xs-12 col-sm-12"
              } : { template: "" };
              _context3.t2 = vm.syncConfig ? {
                template: "<label>Code interne :</label><br/><input value=\"" + (vm.model.label ? vm.model.label : "") + "\" class=\"form-control\" disabled/><div style=\"padding-top: 6px;\"/>",
                className: "col-xs-12 col-sm-12"
              } : FormlyService.text("label", "Code interne", false, {
                className: "col-xs-12 col-sm-12"
              });
              _context3.t3 = FormlyService.list("type", "Type", typesVehiclesList, false, {
                className: "col-xs-12 col-sm-12"
              });
              _context3.t4 = FormlyService;
              _context3.next = 12;
              return InsurerContractsService.getSelectArray();

            case 12:
              _context3.t5 = _context3.sent;
              _context3.t6 = {
                className: "col-xs-12 col-sm-12"
              };
              _context3.t7 = _context3.t4.list.call(_context3.t4, "insurerContract", "Contrat d'assurance", _context3.t5, false, _context3.t6);
              _context3.t8 = [_context3.t0, _context3.t1, _context3.t2, _context3.t3, _context3.t7];
              _context3.t9 = {
                mainTitle: "Identification",
                fields: _context3.t8
              };
              _context3.t10 = {
                mainTitle: "Kilométrage",
                fields: [FormlyService.number("mileage", "Dernier relevé kms", false, {
                  className: "col-xs-12 col-sm-6"
                }), FormlyService.date("mileageDate", "Date du relevé", false, {
                  className: "col-xs-12 col-sm-6"
                })]
              };
              _context3.t11 = {
                mainTitle: "Lieu de parking",
                fields: [FormlyService.text("zipCode", "Code Postal", false, {
                  className: "col-xs-12 col-sm-6"
                }), FormlyService.text("city", "Ville", false, {
                  className: "col-xs-12 col-sm-6"
                })]
              };
              _context3.t12 = {
                mainTitle: "Contrat de location",
                fields: [FormlyService.text("carRentalName", "Nom du loueur", false, {
                  className: "col-xs-12 col-sm-12"
                }), FormlyService.date("carReturnDate", "Date de restitution", false, {
                  className: "col-xs-12 col-sm-6"
                }), FormlyService.number("carRentalCost", "Coût mensuel HT", false, {
                  className: "col-xs-12 col-sm-6"
                })]
              };
              _context3.t13 = [_context3.t9, _context3.t10, _context3.t11, _context3.t12];
              _context3.t14 = {
                class: "col-xs-12 col-sm-4 col-md-4",
                boxes: _context3.t13
              };
              _context3.t15 = {
                mainTitle: "Affectation",
                fields: [{
                  key: "_driverIds",
                  id: "_driverIds",
                  type: "nya-bs-select-multiple",
                  className: "col-xs-12 col-sm-12",

                  templateOptions: {
                    label: "Conducteurs",
                    options: vm.arrayDriver,
                    //required: true,
                    addPage: "user",
                    createButton: true,
                    multiple: "multiple"
                  },

                  controller: ["$scope", function ($scope) {
                    $controller("SelectUserController", {
                      positions: ["Conducteur"],
                      $scope: $scope
                    });
                  }]
                }, {
                  key: "defaultManagerId",
                  id: "defaultManagerId",
                  type: "nya-bs-select",
                  className: "col-xs-12 col-sm-12",

                  templateOptions: {
                    label: "Gestionnaire du véhicule",
                    options: vm.arrayManageur,
                    //required: true,
                    addPage: "user",
                    createButton: true
                  },

                  controller: ["$scope", function ($scope) {
                    $controller("SelectUserController", {
                      positions: [$rootScope.defaultManagerValue, $rootScope.rhManagerValue, $rootScope.qseManagerValue, $rootScope.fleetManagerValue, $rootScope.other1ManagerValue, $rootScope.other2ManagerValue],
                      $scope: $scope
                    });
                  }]
                }, FormlyService.date("inDate", "Date d'entrée", false, {
                  className: "col-xs-12 col-sm-6"
                }), FormlyService.date("outDate", "Date de sortie", false, {
                  className: "col-xs-12 col-sm-6"
                }), {
                  template: "<div class='col-xs-12 col-sm-6' style='padding-top: 6px;'></div>"
                }, FormlyService.currency("restitutionCost", "Coût de restitution", false, {
                  className: "col-xs-12 col-sm-6"
                }), {
                  key: "groupsId",
                  type: "select-groups",
                  className: "col-xs-12 col-sm-12",
                  templateOptions: {
                    label: "Groupes associés :"
                  }
                }]
              };
              _context3.t16 = FormlyService.text("brand", "Marque", false, {
                className: "col-xs-12 col-sm-6"
              });
              _context3.t17 = FormlyService.text("model", "Modèle", false, {
                className: "col-xs-12 col-sm-6"
              });
              _context3.t18 = FormlyService.text("color", "Couleur", false, {
                className: "col-xs-12 col-sm-6"
              });
              _context3.t19 = FormlyService;
              _context3.next = 29;
              return CustomListsService.getSelectArray("typeVehicleCritAir");

            case 29:
              _context3.t20 = _context3.sent;
              _context3.t21 = {
                className: "col-xs-12 col-sm-6"
              };
              _context3.t22 = _context3.t19.list.call(_context3.t19, "critAirType", "Certificat qualité de l'air", _context3.t20, false, _context3.t21);
              _context3.t23 = FormlyService.textArea("note", "Commentaires", "...", false, {
                className: "col-xs-12 col-sm-12"
              });
              _context3.t24 = [_context3.t16, _context3.t17, _context3.t18, _context3.t22, _context3.t23];
              _context3.t25 = {
                mainTitle: "Autre",
                fields: _context3.t24
              };
              _context3.t26 = [_context3.t15, _context3.t25];
              _context3.t27 = {
                class: "col-xs-12 col-sm-4 col-md-4",
                boxes: _context3.t26
              };
              _context3.t28 = {
                mainTitle: "Documents liés au véhicule",
                fields: [FormlyService.doc("docs", "", "vehicle", false, {
                  className: "col-xs-12"
                }, "", false)]
              };
              _context3.t29 = FormlyService;
              _context3.next = 41;
              return CustomListsService.getSelectArray("typeVehicleEngineV2");

            case 41:
              _context3.t30 = _context3.sent;
              _context3.t31 = {
                className: "col-xs-12 col-sm-12"
              };
              _context3.t32 = _context3.t29.list.call(_context3.t29, "engineType", "Source d'énergie", _context3.t30, false, _context3.t31);
              _context3.t33 = FormlyService.bool("parkingAidRear", "Radar de recul", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t34 = FormlyService.bool("parkingAidFront", "Radar avant", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t35 = FormlyService.bool("cameraRear", "Caméra de recul", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t36 = FormlyService.bool("cameraFront", "Caméra avant", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t37 = FormlyService.bool("laneDepartureWarning", "Alerte Franchissement de Ligne (LDW)", false, {
                className: "col-xs-12 col-sm-8"
              });
              _context3.t38 = FormlyService.bool("airConditioning", "Climatisation", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t39 = FormlyService.bool("gps", "GPS", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t40 = FormlyService.bool("cruiseControl", "Régul. de vitesse", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t41 = FormlyService.bool("limitControl", "Limiteur de vitesse", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t42 = FormlyService.bool("adaptiveCruiseControl", "Régul. de vitesse adaptatif (ACC)", false, {
                className: "col-xs-12 col-sm-8"
              });
              _context3.t43 = FormlyService.bool("allSeasonTire", "Pneus 4 saisons", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t44 = FormlyService.date("allSeasonTireLastDate", "Date montage", false, {
                className: "col-xs-12 col-sm-8"
              });
              _context3.t45 = FormlyService.bool("winterTire", "Pneus hiver", false, {
                className: "col-xs-12 col-sm-4"
              });
              _context3.t46 = FormlyService.date("winterTireLastDate", "Date montage", false, {
                className: "col-xs-12 col-sm-8"
              });
              _context3.t47 = [_context3.t32, _context3.t33, _context3.t34, _context3.t35, _context3.t36, _context3.t37, _context3.t38, _context3.t39, _context3.t40, _context3.t41, _context3.t42, _context3.t43, _context3.t44, _context3.t45, _context3.t46];
              _context3.t48 = {
                mainTitle: "Équipements",
                fields: _context3.t47
              };
              _context3.t49 = [_context3.t28, _context3.t48];
              _context3.t50 = {
                class: "col-xs-12 col-sm-4 col-md-4",
                boxes: _context3.t49
              };
              _context3.t51 = [_context3.t14, _context3.t27, _context3.t50];
              _context3.t52 = {
                columns: _context3.t51
              };
              vm.rows = [_context3.t52];


              $timeout(function () {}, 10);

            case 66:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
  }
})();